export default {
  light: {
    name: 'light',
    messages: {
      backgroundColor: 'white',
      color: '#000000'
    },
    bar: {
      backgroundColor: 'white',
      color: '#000000',
      borderBottom: '1px solid rgba(0,0,0,0.3)'
    },
    windowBar: {
      backgroundColor: '#dfdfdf'
    },
    messageWrap: {
      borderBottom: '1px solid #e6ecf0'
    },
    colors: {
      dimmed: '#647787',
      icon: '#72bfff',
      text: '#565656',
      featureIcon:"#233448",
    },
    button: {
      background: 'rgba(255, 255, 255, 0.8)',
      backgroundHover: 'rgba(255, 255, 255, 0.9)',
      color: '#565656'
    },
    composeInput: {
      backgroundColor: 'rgb(245, 248, 250)',
      color: '#000000'
    },
    composeWindow: {
      backgroundColor: '#ffffff'
    },
    composeBar: {
      backgroundColor: '#ffffff',
      borderBottom: '1px solid rgba(0,0,0,0.3)'
    },
    bodyText:{
      color: "#565656"
    }
  },
  dark: {
    name: 'dark',
    messages: {
      backgroundColor: '#1a2837'
    },
    bar: {
      backgroundColor: '#233448',
      borderBottom: '1px solid rgba(0,0,0,0)'
    },
    messageWrap: {
      borderBottom: '1px solid rgba(0,0,0,0.5)'
    },
    windowBar: {
      backgroundColor: '#16202d'
    },
    colors: {
      dimmed: '#8799a7',
      icon: '#72bfff',
      text: 'white',
      featureIcon: "#72bfff",
    },
    button: {
      background: 'rgba(255, 255, 255, 0.2)',
      backgroundHover: 'rgba(255, 255, 255, 0.3)',
      color: '#fff'
    },
    composeInput: {
      backgroundColor: '#192530',
      color: 'white'
    },
    composeWindow: {
      backgroundColor: '#1a2836'
    },
    composeBar: {
      backgroundColor: '#243547',
      borderBottom: '1px solid rgba(0,0,0,0)'
    }
  }
};
